import React from "react";
import { MdCheck, MdCheckCircle, MdRadioButtonUnchecked } from "react-icons/md";

const cx = (...classes) => classes.filter(Boolean).join(" ");

/**
 * Selectable answer row for public surveys: a toggle button (`aria-pressed`) with a
 * check indicator, so the selection never relies on color alone.
 *
 * @param {object} props
 * @param {boolean} props.selected
 * @param {() => void} props.onClick
 * @param {boolean} [props.multiple=false] Square checkbox indicator instead of a radio circle.
 * @param {React.ReactNode} [props.leading] Content before the label, e.g. an "A" letter tile.
 * @param {string} [props.className]
 */
const ChoiceOption = ({ selected, onClick, multiple = false, leading, className, children }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={selected}
    className={cx(
      "flex w-full items-center gap-3 rounded-control border px-4 py-3 text-left text-sm font-medium text-fg transition-colors focus-ring",
      selected
        ? "border-primary bg-primary/10 dark:border-accent dark:bg-accent/15"
        : "border-line bg-surface hover:bg-surface-subtle",
      className
    )}
  >
    {leading}
    <span className="flex-1 leading-snug">{children}</span>
    {multiple ? (
      <span
        aria-hidden="true"
        className={cx(
          "flex h-5 w-5 shrink-0 items-center justify-center rounded border-2",
          selected
            ? "border-primary bg-primary text-primary-fg dark:border-accent dark:bg-accent dark:text-canvas"
            : "border-line"
        )}
      >
        {selected && <MdCheck className="h-4 w-4" />}
      </span>
    ) : selected ? (
      <MdCheckCircle aria-hidden="true" className="h-5 w-5 shrink-0 text-primary dark:text-accent" />
    ) : (
      <MdRadioButtonUnchecked aria-hidden="true" className="h-5 w-5 shrink-0 text-fg-muted" />
    )}
  </button>
);

export default ChoiceOption;
